/**
 * The one attribution question Tabbio asks: "Where did you hear about us?".
 *
 * The option keys double as the `auth:onboarding.whereHeard.options.*` copy
 * keys and as the `whereHeard` enum the API stores (onboardingPreferencesSchema),
 * so the preserved onboarding step (StepWhereHeard) and the in-app prompt
 * (WhereHeardPrompt, shown once when a CV is opened from My Tabbio) stay on
 * one list. Add an option here, in both locales and in the API schema together.
 */
export const WHERE_HEARD_OPTIONS = [
  "appStore",
  "google",
  "friend",
  "social",
  "other",
] as const;
export type WhereHeardOption = (typeof WHERE_HEARD_OPTIONS)[number];

/** Second-level pick behind "Social media" on the onboarding step. */
export const WHERE_HEARD_SOCIAL_PLATFORMS = [
  "instagram",
  "linkedin",
  "tiktok",
  "x",
  "youtube",
  "facebook",
] as const;
export type WhereHeardSocialPlatform = (typeof WHERE_HEARD_SOCIAL_PLATFORMS)[number];

/** Where the question was answered: the `placement` property of `onboarding_where_heard`. */
export type WhereHeardPlacement = "onboarding" | "my_tabbio_cv";
